import { defineStore } from 'pinia'

export const useUiStore = defineStore('ui', {
  state: () => ({
    isPromoMode: true,
  }),
  actions: {
    togglePromoMode() {
      this.isPromoMode = !this.isPromoMode
    },
  },
})
